import LoopSlider from "./LoopSlider";
import Swiper from "swiper";
import {
	Pagination,
	Autoplay,
	Navigation,
	EffectFade,
	Thumbs,
	Scrollbar,
} from "swiper/modules";

$(document).ready(() => {
	const homeBannerThumbSlider = new Swiper(
		".home-banner-thumb-slider .swiper",
		{
			slidesPerView: "auto",
			spaceBetween: 0,
			loop: true,
			watchSlidesProgress: true,
			slideToClickedSlide: true,
			breakpoints: {
				1024: {
					slidesPerView: 6,
				},
			},
		}
	);

	const homeBannerSlider = new Swiper(".home-banner-slider .swiper", {
		modules: [Autoplay, EffectFade, Navigation, Thumbs],
		slidesPerView: "1",
		spaceBetween: 0,
		effect: "fade",
		loop: true,
		observer: true,
		observeParents: true,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		thumbs: {
			swiper: homeBannerThumbSlider,
		},
		on: {
			slideChange: function () {
				let activeIndex = this.activeIndex + 1;

				let nextSlide = $(
					`.home-banner-thumb-slider .swiper-slide:nth-child(${
						activeIndex + 1
					})`
				);
				let prevSlide = $(
					`.home-banner-thumb-slider .swiper-slide:nth-child(${
						activeIndex - 1
					})`
				);

				if (nextSlide && !nextSlide.hasClass("swiper-slide-visible")) {
					this.thumbs.swiper.slideNext();
				} else if (
					prevSlide &&
					!prevSlide.hasClass("swiper-slide-visible")
				) {
					this.thumbs.swiper.slidePrev();
				}
			},
		},
	});

	const partnerSlider = new Swiper(".partner-slider .swiper", {
		modules: [Autoplay, Navigation],
		slidesPerView: 2.5,
		spaceBetween: 16,
		loop: true,
		speed: 2000,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: ".partner-slider .swiper-btn-next",
			prevEl: ".partner-slider .swiper-btn-prev",
		},
		breakpoints: {
			576: {
				slidesPerView: 4.5,
			},
			768: {
				slidesPerView: 5.5,
			},
			1024: {
				slidesPerView: 6,
				spaceBetween: 40,
			},
		},
	});

	const singleSlider = new LoopSlider(".single-slider", {
		1024: {
			spaceBetween: 40,
			slidesPerView: 1,
		},
	});

	const doubleSlider = new LoopSlider(".double-slider", {
		576: {
			spaceBetween: 20,
			slidesPerView: 1.5,
		},
		1024: {
			spaceBetween: 40,
			slidesPerView: 2,
		},
	});

	const tripleSlider = new LoopSlider(".triple-slider", {
		576: {
			spaceBetween: 20,
			slidesPerView: 2.5,
		},
		1024: {
			spaceBetween: 40,
			slidesPerView: 3,
		},
	});

	const quadrupleSlider = new LoopSlider(".quadruple-slider", {
		576: {
			spaceBetween: 20,
			slidesPerView: 2.5,
		},
		768: {
			spaceBetween: 20,
			slidesPerView: 3.5,
		},
		1024: {
			spaceBetween: 40,
			slidesPerView: 4,
		},
	});
});
